
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: '高単価案件が中心',
      description: '単独160万円〜210万円クラスの案件を中心にご紹介しています。'
    },
    {
      icon: 'ri-line-chart-line',
      title: '上流工程案件が豊富',
      description: '戦略・構想・要件定義など上流工程プロジェクトが中心です。'
    },
    {
      icon: 'ri-time-line',
      title: '稼働率調整可能',
      description: '20%〜100%まで稼働率を調整可能です。'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '長期案件が多数',
      description: '6ヶ月以上の長期案件が中心です。'
    }
  ];

  return (
    <section id="benefits" className="py-8 sm:py-12 bg-[#112240]">
      <div className="container mx-auto px-4">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-4 sm:mb-6 text-white">
          プロジェクトマスターに登録する特典
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-[#1a2f4e] p-3 sm:p-4 rounded-lg hover:bg-[#1e3a5f] transition-colors border border-slate-700">
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center mb-2">
                <i className={`${benefit.icon} text-2xl sm:text-3xl text-amber-400`}></i>
              </div>
              <h3 className="font-bold text-xs sm:text-sm mb-1 text-white">{benefit.title}</h3>
              <p className="text-xs text-slate-300 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
